const PATHNAME_REGEX = {
  OLDPDP: /^\/product-landing/i,
  PDP: /^\/pdp\/([^/]+)/i,
  BRANDCLUB: /^\/(brandclub)/i,
  BRAND: /^\/(brand)/i
};
const PATHNAME_CHECKER = {
  isOldPDP: (pathname) => pathname ? PATHNAME_REGEX.OLDPDP.exec(pathname) : false,
  isPDP: (pathname) => pathname ? PATHNAME_REGEX.PDP.exec(pathname) : false,
  isBrandPage: (pathname) => pathname ? PATHNAME_REGEX.BRAND.exec(pathname) : false,
  isBrandclubPage: (pathname) => pathname ? PATHNAME_REGEX.BRANDCLUB.exec(pathname) : false
};
const copyTrackingParamsToUrlSearchParams = (trackingParams, urlSearchParams = new URLSearchParams()) => {
  Object.entries(trackingParams).forEach((c) => {
    const key = c[0];
    const val = c[1];
    if (key && val !== void 0) {
      urlSearchParams.set(key, val + "");
    }
  }, {});
  return urlSearchParams;
};
export {
  PATHNAME_CHECKER,
  PATHNAME_REGEX,
  copyTrackingParamsToUrlSearchParams
};
//# sourceMappingURL=LocationTrackingUtils.js.map
